export const subjectMixin = {
  methods: {
    getSubjectDescription(subjectId) {
      const subject = this.$store.state.subjects.find(
        ({ id }) => id === subjectId
      );
      if (subject) {
        return subject.description;
      }
      return "";
    }
  }
};
